export default "__VITE_ASSET__DxYXV72U__"